// AI-generated hero/marketing tile images.
// All rendered in the same dark walnut butcher-block studio style as product photos
// so the site feels visually cohesive end-to-end.
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

const heroImg = (slug) => `${BACKEND}/api/files/hero/${slug}.png`;
// Optimised WebP versions in /public/hero/ — used for above-the-fold tiles
// where speed matters (landing hero strip, ~200px displayed width so 640w is
// plenty). ~95% smaller than the source PNG.
const heroWebp = (slug) => `/hero/${slug}-640.webp`;

// Category-based image fallback used when a product image_url is empty.
export const CATEGORY_FALLBACK_IMG = {
  beef: heroImg('beef'),
  lamb: heroImg('lamb'),
  poultry: heroImg('poultry'),
  crumbed: heroImg('crumbed'),
  burgers: heroImg('burgers'),
  sausages: heroImg('sausages'),
  smallgoods: heroImg('smallgoods'),
  jerky: heroImg('jerky'),
  pies: heroImg('pies'),
};

export const HERO_TILE_IMG = {
  beef: heroWebp('beef'),
  lamb: heroWebp('lamb'),
  wagyu: heroWebp('wagyu'),
  poultry: heroWebp('poultry'),
  smallgoods: heroWebp('smallgoods'),
  crumbed: heroWebp('crumbed'),
  burgers: heroWebp('burgers'),
  sausages: heroWebp('sausages'),
  jerky: heroWebp('jerky'),
  pies: heroWebp('pies'),
};

export const CRAFT_IMG = heroImg('craft');
